import React from 'react';
import NotFoundImg from 'Assets/images/pages/web-chat/notfound.svg';

import css from './SearchNotFound.less';

const SearchNotfound = () => (
  <div className={css.notfound}>
    <img className={css.notfoundImg} src={NotFoundImg} alt="notfound img" />
    <h4 className={css.title}>No medicine found</h4>
    <p className={css.desc}>Please try another keywords</p>
  </div>
);

export default SearchNotfound;
